<template>
  <div :data-vv-as="$attrs['data-vv-as']" data-vv-validate-on="change">
    <input
      ref="input"
      :id="id"
      :name="name"
      :value="value"
      :checked="checked === value"
      :type="type"
      v-bind="$attrs"
      class="large"
      @change="handleChange"
    />
    <span class="visual-checkbox-input" @click="handleChange">
      <slot />
    </span>
  </div>
</template>

<script>
// @flow
// TODO: vee validate 3 - format changes

/**
 * Checkbox (or Radio) input that will take a custom slot for the "visual checkbox"
 * - uses v-model with @change instead of @input
 * - must pass in id, name, value and v-model
 * - must pass in data-vv-as for vee-validate
 * - must not have a label (use :show-label="false" on form-group-inline)
 */
export default {
  inject: ['$validator'],
  name: 'VisualInput',
  inheritAttrs: false,
  // custom v-model for checkbox to use change event @see https://vuejs.org/v2/api/#model
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: (val: string) => ['radio', 'checkbox'].includes(val),
    },

    // not tied to v-model (see model above), but actual prop
    value: {
      type: String,
      default: '',
    },

    // used with v-model
    checked: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    handleChange() {
      if (!this.$refs.input.disabled) {
        const value = this.$refs.input.value
        this.$emit('change', value)
      }
    },
  },
}
</script>
